import moment from 'moment-timezone';
import { DeviceDataOverrideService } from "../services";

class GraphDataConverter {

  static hasStateValue(readings) {
    if (readings) {
      for(var i=0; i<readings.length; i++) {
        if (readings[i].state) {
          return true;
        }
      }
    }
    return false;
  }

  static convertReadingDataToGraphData(dataTypeToken, timezone, readings, endAtDate, timeframe, limitReadings, limitSampleRateMillis) {
    if (dataTypeToken === 'magnetometer' || dataTypeToken === 'door_open' || this.hasStateValue(readings)) {
      return this.convertReadingDataToGraphDataState(timezone, readings, endAtDate, timeframe);
    } else if (limitReadings && limitSampleRateMillis) {
      return this.convertReadingDataToGraphDataClamped(timezone, readings, limitSampleRateMillis, DeviceDataOverrideService.getOverrideFunctionForDeviceTypeToken(dataTypeToken));
    } else {
      return this.convertReadingDataToGraphDataDefault(timezone, readings, DeviceDataOverrideService.getOverrideFunctionForDeviceTypeToken(dataTypeToken));
    }
  }

  static convertReadingDataToGraphDataState(timezone, readings, requestedEndAtDate, timeframe) {
    var stateInit = false;
    var lastState = null;
    let stateTransitionData = [];

    readings
      .sort((a, b) => {return a.timestamp - b.timestamp})
      .filter(reading => {
        if (stateInit) {
          const stateTransition = lastState !== reading.state;
          lastState = reading.state;
          return stateTransition;
        } else {
          stateInit = true;
          lastState = reading.state;
          return true;
        }
      })
      .forEach(reading => {
        if (stateTransitionData.length === 0) {
          const requestedStartAtTime = Math.round(requestedEndAtDate / 1000) - timeframe;
          const actualStartAtTime = Math.round(reading.timestamp / 1000);

          stateTransitionData.push({
            state: reading.state,
            startTimestamp: Math.min(requestedStartAtTime, actualStartAtTime),
            endTimestamp: null,
            stateRuntime: null
          });
        } else {
          let previousDataPoint = stateTransitionData[stateTransitionData.length - 1];
          let currentReadingTS = Math.round(reading.timestamp / 1000);
          let stateRuntime = currentReadingTS - previousDataPoint.startTimestamp;

          if (stateRuntime > 0) {
            previousDataPoint.endTimestamp = currentReadingTS;
            previousDataPoint.stateRuntime = stateRuntime;

            stateTransitionData.push({
              deviceName: reading.deviceName,
              state: reading.state,
              startTimestamp: currentReadingTS,
              endTimestamp: null,
              stateRuntime: null
            });
          }
        }
      });

    let currentTS = moment.now();
    let actualEndAtDate = (requestedEndAtDate > currentTS) ? currentTS : requestedEndAtDate;

    let lastDataPoint = stateTransitionData[stateTransitionData.length - 1];
    lastDataPoint.endTimestamp = Math.round(actualEndAtDate / 1000);
    lastDataPoint.stateRuntime = lastDataPoint.endTimestamp - lastDataPoint.startTimestamp;

    return stateTransitionData.map(transition => {
      let startUTCOffset = timezone ? moment(transition.startTimestamp * 1000).tz(timezone).utcOffset() : moment(transition.startTimestamp * 1000).utcOffset();
      let endUTCOffset = timezone ? moment(transition.endTimestamp * 1000).tz(timezone).utcOffset() : moment(transition.endTimestamp * 1000).utcOffset();

      return ({
        state: transition.state,
        startTimestamp: transition.startTimestamp + Math.round((startUTCOffset) * 60),
        endTimestamp: transition.endTimestamp + Math.round((endUTCOffset) * 60),
        length: transition.stateRuntime
      });
    });
  }

  static convertReadingDataToGraphDataClamped(timezone, readings, limitSampleRateMillis, fnToApply) {
    let currTimestamp = 0;

    return readings
        .sort((a, b) => {return a.timestamp - b.timestamp})
        .filter(reading => {
          if (reading.timestamp >= currTimestamp + limitSampleRateMillis) {
            currTimestamp = reading.timestamp;
            return reading;
          }})
        .map(reading => {
          let utcOffset = timezone ? moment(reading.timestamp).tz(timezone).utcOffset() : moment(reading.timestamp).utcOffset();
          return ({
            deviceName: reading.deviceName,
            amount: fnToApply(reading.amount),
            timestamp: Math.round(reading.timestamp / 1000) + (utcOffset * 60)
          });
      });
  }

  static convertReadingDataToGraphDataDefault(timezone, readings, fnToApply) {
    return readings.map(reading => {
        let utcOffset = timezone ? moment(reading.timestamp).tz(timezone).utcOffset() : moment(reading.timestamp).utcOffset();
        return ({
          deviceName: reading.deviceName,
          amount: fnToApply(reading.amount),
          timestamp: Math.round(reading.timestamp / 1000) + (utcOffset * 60)
        });
      });
  }

  static convertOutagesToGraphData(outages, timezone) {
    return outages.map(outage => {
      let utcOffset = timezone ? moment(outage.start).tz(timezone).utcOffset() : moment(outage.start).utcOffset();
      return ({
        start: Math.round(outage.start / 1000) + (utcOffset * 60), 
        end: Math.round(outage.end / 1000) + (utcOffset * 60) 
      });   
    });
  }

}

export default GraphDataConverter;
